import React from "react";

function ProjectDiv(props) {
  return (
    <div className="project-div">
      <a href={props.link} target="_blank" aria-label={props.dis}>
        <figure>
          <img
            className="project-ss-img"
            src={props.pic}
            alt="Project Snapshot"
          />
          <figcaption className="fig-caption">Project SnapShot</figcaption>
        </figure>
        <h3 className="project-title">{props.title}</h3>
        <p className="project-dis">{props.dis}</p>
      </a>
      <div>
        <span className="tech-stack">{props.techOne} </span>
        <span className="tech-stack">{props.techTwo} </span>
      </div>
    </div>
  );
}

export default ProjectDiv;
